/* The mockup's `.swatch`: a 12px rounded square with a faint inner ring, neutral until known. */
.swatch {
  flex: none;
  border-radius: 3px;
  background: var(--swatch, var(--surface-sunken));
  inline-size: 12px;
  block-size: 12px;
  box-shadow: inset 0 0 0 1px var(--border);
}
